if (!customElements.get('tooto-trending-carousel')) {
  class TootoTrendingCarousel extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.retryFrame = null;
      this.retryCount = 0;
      this.isBound = false;
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleSectionUnload = this.handleSectionUnload.bind(this);
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      if (!this.isBound) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:section:unload', this.handleSectionUnload);
        this.addEventListener('click', this.handleClick);
        this.isBound = true;
      }

      this.initialize();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      document.removeEventListener('shopify:section:unload', this.handleSectionUnload);
      this.removeEventListener('click', this.handleClick);
      this.isBound = false;
      this.destroy();
    }

    initialize() {
      if (this.swiper) return;

      const slider = this.querySelector('.tooto-trending__carousel');
      const slides = slider?.querySelectorAll('.swiper-wrapper > .tooto-trending__slide-item');

      if (!slider || !slides?.length) return;

      if (slides.length === 1) {
        this.classList.add('is-static');
        return;
      }

      this.classList.remove('is-static');

      if (typeof window.Swiper !== 'function') {
        if (this.retryCount < 180) {
          this.retryCount += 1;
          this.retryFrame = requestAnimationFrame(() => this.initialize());
        }
        return;
      }

      const previousButton = this.querySelector('.tooto-trending__button--previous');
      const nextButton = this.querySelector('.tooto-trending__button--next');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.retryCount = 0;
      this.swiper = new window.Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: false,
        speed: reducedMotion ? 0 : 600,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        roundLengths: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        mousewheel: {
            enabled: true,
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 1,
        },
        navigation: {
          prevEl: previousButton,
          nextEl: nextButton,
        },
        a11y: {
          enabled: true,
          prevSlideMessage: this.dataset.previousLabel,
          nextSlideMessage: this.dataset.nextLabel,
        },
        breakpoints: {
          750: {
            loop: true,
            spaceBetween: 16,
          },
        },
      });
    }

    destroy() {
      if (this.retryFrame) {
        cancelAnimationFrame(this.retryFrame);
        this.retryFrame = null;
      }

      if (this.swiper && !this.swiper.destroyed) {
        this.swiper.destroy(true, true);
      }

      this.swiper = null;
      this.retryCount = 0;
    }

    handleBlockSelect(event) {
      const selectedSlide = event.target.closest?.('.tooto-trending__slide-item');
      if (!selectedSlide || !this.contains(selectedSlide) || !this.swiper) return;

      const originalSlides = Array.from(
        this.querySelectorAll('.swiper-wrapper > .tooto-trending__slide-item:not(.swiper-slide-duplicate)')
      );
      const slideIndex = originalSlides.findIndex((slide) => slide.dataset.blockId === selectedSlide.dataset.blockId);

      if (slideIndex < 0) return;

      if (this.swiper.params.loop && typeof this.swiper.slideToLoop === 'function') {
        this.swiper.slideToLoop(slideIndex, 300);
      } else {
        this.swiper.slideTo(slideIndex, 300);
      }
    }

    handleSectionUnload(event) {
      if (event.target.contains(this)) this.destroy();
    }

    handleClick(event) {
      if (this.dataset.designMode !== 'true') return;

      const link = event.target.closest?.('.tooto-trending__slide[href]');
      if (link && this.contains(link)) event.preventDefault();
    }
  }

  customElements.define('tooto-trending-carousel', TootoTrendingCarousel);
}
